import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../context/AuthContext';

export default function CheckoutSuccessPage() {
    const { user } = useAuth();
    const brandColor = '#e46809';

    return (
        <div className="container mx-auto px-4 py-16 text-center">
            <CheckCircleIcon className="w-24 h-24 mx-auto text-green-500" />
            <h1 className="mt-4 text-3xl font-bold text-gray-800 dark:text-white">Thank You for Your Gift!</h1>
            <p className="mt-2 text-lg text-gray-500 dark:text-gray-400">
                Your generous donation has been processed successfully. You are making a real difference.
            </p>
            <div className="mt-8 flex justify-center gap-4">
                <Link
                  to="/"
                  className="inline-block py-3 px-8 text-white font-semibold rounded-lg transition-colors"
                  style={{ backgroundColor: brandColor }}
                >
                  Back to Homepage
                </Link>
                {user && (
                    <Link
                      to="/donor/gifts"
                      className="inline-block py-3 px-8 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-semibold rounded-lg transition-colors"
                    >
                      View My Gifts
                    </Link>
                )}
            </div>
        </div>
    );
}